import * as React from "react";
import { Field } from "formik";
import StringUtils from "util/StringUtils";
import { Select, InputDescription } from "components/common";
const DayOfWeekSelect = ({ id, required = false }) => {
  const dow = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].map((day) => ({
    value: day,
    label: StringUtils.capitalizeFirstLetter(day)
  }));
  return /* @__PURE__ */ React.createElement(Field, { name: id }, ({ field: { name, value, onChange, onBlur }, meta: { error, touched } }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Select,
    {
      onBlur,
      onChange: (newValue) => onChange({
        target: { value: newValue, name }
      }),
      options: dow,
      inputId: name,
      placeholder: "Select day of the week",
      required,
      value: value ? StringUtils.stringify(value) : ""
    }
  ), error && touched && /* @__PURE__ */ React.createElement(InputDescription, { error, className: "no-bm" })));
};
export default DayOfWeekSelect;
